import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { coverageAssessmentToolDTOModal, coverageDTO, coverageDTOModal } from 'src/app/models/coverageDTO';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { PropagationType, RangeLimitation, CalculationType, CoverageAlgorithmType } from 'src/app/models/EnumTypes';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-coverage-assessment',
  templateUrl: './coverage-assessment.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class CoverageAssessmentComponent implements OnInit {

  singleLevel : boolean = false;
  groundLevel : boolean = false;

  propagationType : string[] = Object.values(PropagationType);
  rangeLimitation : string[] = Object.values(RangeLimitation);
  calculationType : string[] = Object.values(CalculationType);
  coverageAlgorithmType : string[] = Object.values(CoverageAlgorithmType);

  calculationTypeDisabled : boolean = false;
  coverageAlgorithmDisabled : boolean = false;
  readonly forbiddenSubstringName = TabsService.SEPARATOR;

  constructor(
    private modalService: ModalControlService,
    public bsModalRef : BsModalRef,
    public calculationControlService : CalculationsControlService,
    public pointsController : PointsService
  ) {
    this.calculationControlService.coverageDTO = new coverageDTO();
    this.calculationControlService.coverageAssessmentDTOModal = new coverageAssessmentToolDTOModal();
    this.calculationControlService.coverageAssessmentDTOModal.propagationType = "0"; // line of Sight
    this.calculationControlService.coverageAssessmentDTOModal.rangeLimitation = "DOC";
    this.calculationControlService.coverageAssessmentDTOModal.calculationType = "Coverage";
    this.calculationControlService.coverageAssessmentDTOModal.coverageAlgorithm = "Screening";
   }

  ngOnInit(): void {
    this.calculationControlService.getCoverageAssessmentToolDefaultAltitudes();
  }

  cancelCoverageAssessmentTool():void {
    this.bsModalRef.hide();
  }

  singleLevelActive():void{
    this.singleLevel = !this.singleLevel;
    this.calculationControlService.coverageAssessmentDTOModal.isSingleLevel = !this.calculationControlService.coverageAssessmentDTOModal.isSingleLevel;~
    this.calculationControlService.getCoverageAssessmentToolDefaultAltitudes();
  }

  onChangeCalculationType(value : any){
    if(value == "Cumulative Coverage"){
      this.coverageAlgorithmDisabled = true;
      this.calculationControlService.coverageAssessmentDTOModal.coverageAlgorithm = "Visibility";
    }else {
      this.coverageAlgorithmDisabled = false;
    }
  }
  onChangePropagation(value : any){
    if(value == 1 || value ==  2){
      this.calculationControlService.coverageAssessmentDTOModal.calculationType = "Coverage";
      this.calculationControlService.coverageAssessmentDTOModal.coverageAlgorithm = "Visibility";
      this.rangeLimitation = ["DOC", "Radio Horizon"];
      this.calculationTypeDisabled = true;
      this.coverageAlgorithmDisabled = true;
    }else {
      this.calculationTypeDisabled = false;
      this.coverageAlgorithmDisabled = false;
      this.propagationType = ["Line of sight", "Diffraction (Knife-Edge model)", "Diffraction (60% Simplification)"];
      this.rangeLimitation = ["DOC", "Radio Horizon", "FSPL", "FOM"];
    }
  }
  onRangeLimitation(value : any){
    if(value == "FSPL"){
      this.calculationControlService.coverageAssessmentDTOModal.coverageAlgorithm = "Screening";
      this.calculationControlService.coverageAssessmentDTOModal.calculationType = "Coverage";
      this.calculationTypeDisabled = true;
      this.coverageAlgorithmDisabled = true;
    }else {
      this.coverageAlgorithmDisabled = false;
      this.calculationTypeDisabled = false;
    }
  }
  groundLevelActive():void{
    this.groundLevel = !this.groundLevel;

    if(this.groundLevel){
      //this.calculationControlService.coverageAssessmentDTOModal.calculationType = "Coverage";
      this.calculationControlService.coverageAssessmentDTOModal.coverageAlgorithm = "Visibility";
      this.propagationType = ["Line of sight"];
      this.rangeLimitation = ["DOC", "Radio Horizon", "FOM"];
    }else {
      this.propagationType = ["Line of sight", "Diffraction (Knife-Edge model)", "Diffraction (60% Simplification)"];
      this.rangeLimitation = ["DOC", "Radio Horizon", "FSPL", "FOM"];
    }
 }

 calculate(){
  this.calculationControlService.coverageAssessmentToolCalculationInitialization();
  this.bsModalRef.hide();
 }

}
